import axios from 'axios'

// 末尾の/を削除
let host = process.env.VUE_APP_API_ENDPOINT

// Cookieを使用しているのでwithCredentials: true 必須
let client = axios.create({
  baseURL: host,
  withCredentials: false,
  withXSRFToken: true,
  headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
  responseType: 'json',
  timeout : 50000,
})

const setting = {
  install (Vue, { store }) {

    client.interceptors.request.use(
      function (config) {

        let accessToken = null;
        if (config.url.indexOf('driver') > 0) {
          accessToken = store.getters['DriverAuthentication/accessToken'];

        } else if (config.url.indexOf('admin') > 0) {
          accessToken = store.getters['AdminAuthentication/accessToken'];
        }

        if (accessToken) {
          config.headers['Authorization'] = `Bearer ${accessToken}`
        }

        const skip_loading_urls = ['/driver/api/v1/notifications/unread_count', '/driver/api/v1/tenants/configuration', '/driver/api/v1/topics']
        if (store.getters['DriverAuthentication/tenantId']) {
          config.headers.common['TenantId'] = store.getters['DriverAuthentication/tenantId']
        }
        store.commit('alertMessage/reset')
        if (!skip_loading_urls.includes(config.url)) {
          store.commit('loading/started')
        }
        return config
      },
      function (error) {
        store.commit('loading/finished')
        return Promise.reject(error)
      }
    )
    client.interceptors.response.use(
      function (response) {
        store.commit('loading/finished')
        // result.codeが503001などの場合はエラー表示（分岐をまとめる）
        // withCredentials: true の場合、ヘッダーにaccess-control-allow-origin: * 設定した場合にCROSエラーとなるので
        // メンテナンスは表示できない問題あり
        if (response?.data?.result?.code === '503001') {
          const message = response.data.result.message || '【DXE Station】現在メンテナンス中です...';
          store.commit('snackbar/showError', { message })
          store.commit('alertMessage/showError', { message })
          // エラーとしてreject
          return Promise.reject({ response })
        }
        return response.data
      },
      function (error) {
        // APIエラーのハンドリング
        console.warn('API error', error)
        if (error.response) {
          console.warn('API error status:', error.response.status)
          console.warn('API error headers:', error.response.headers)
          console.warn('API error data:', error.response.data)
        } else {
          console.warn('No response received from API')
        }
        console.warn('API error message', error.message)

        // デフォルトメッセージ
        let message = 'エラーが発生しました';
        if (error.response?.data?.result) {
          message = error.response.data.result.message || message;
        }

        if (error?.config?.url?.indexOf('driver') > 0 || error?.response?.config?.url?.indexOf('driver') > 0) {
          if (error?.response?.status === 401) {
            store.commit('DriverAuthentication/forceSignOut')
            store.commit('snackbar/showError', {message: message})
            store.commit('alertMessage/showError', {message: message})
          } else if (error?.response?.status === 403){
            store.commit('DriverAuthentication/forceSignOut')
            store.commit('authorizationErrorDialog/showMessage', { message: message })
          } else if (error?.response?.status === 406) {
            store.commit('DriverAuthentication/forceSignOut')
            store.commit('authorizationErrorDialog/showMessage', { message: message })
          } else if (error?.response?.status === 423) {
            store.commit('systemMessageDialog/showError', { title: 'お知らせ', message: message })
            store.commit('loading/finished')
          } else {
            store.commit('loading/finished')
            store.commit('snackbar/showError', { message: message })
            store.commit('alertMessage/showError', { message: message })
          }
        } else if (error?.config?.url?.indexOf('admin') || error?.response?.config?.url?.indexOf('admin') > 0) {
          if (error?.response?.status === 401) {
            store.commit('AdminAuthentication/forceSignOut')
            store.commit('snackbar/showError', { message: message })
            store.commit('alertMessage/showError', { message: message })
          } else {
            store.commit('snackbar/showError', { message: message })
            store.commit('alertMessage/showError', { message: message })
          }
        } else if (error?.config?.url?.indexOf('edi_request') > 0 || error?.response?.config?.url?.indexOf('edi_request') > 0) {
          // EDI Request のエラーハンドリング
          store.commit('snackbar/showError', { message: message })
        }
        store.commit('loading/finished')
        return Promise.reject(error)
      }
    )
    Vue.$http = Vue.prototype.$http = client
  }
}

export default setting
